;(function () {
	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		let hideMenuTimeout

		header.addEventListener('keydown', (e) => {
			if (e.code === 'Escape' && search.isOpen) {
				search.close()
			}
		})

		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		const megaMenus = document.querySelectorAll('.mega-menu')

		menuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				clearTimeout(hideMenuTimeout)

				if (link.classList.contains('list-menu--megamenu')) {
					link.classList.add('list-menu--megamenu-visible')

					if (!megaMenus) return

					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0
							megaMenu.style.display = 'grid'
							setTimeout(() => {
								megaMenu.style.opacity = 1
							}, 100)
						}

						const headerMain = header.querySelector('.header')

						const calcPosition = () => {
							megaMenu.style.right = 'auto'

							const megaMenuTabs = megaMenu.querySelector('.mega-menu__tabs')

							if (megaMenuTabs) {
								if (megaMenuTabs.scrollWidth > megaMenu.offsetWidth) {
									megaMenu.style.maxWidth = `${megaMenuTabs.scrollWidth}px`
									megaMenu.style.width = `${megaMenuTabs.scrollWidth}px`
								}
							}

							const megaMenuRight = megaMenu.getBoundingClientRect().right
							const headerRight = headerMain.getBoundingClientRect().right

							if (megaMenuRight > headerRight) {
								megaMenu.style.right = '2rem'
							}
						}

						calcPosition()

						let headerMainWidth = headerMain.offsetWidth

						const resizeObserver = new ResizeObserver((entries) => {
							for (const entry of entries) {
								const newWidth = entry.contentRect.width

								if (newWidth !== headerMainWidth) {
									headerMainWidth = newWidth
									calcPosition()
								}
							}
						})

						resizeObserver.observe(headerMain)
					})

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
			link.addEventListener('mouseleave', (e) => {
				if (link.classList.contains('list-menu--megamenu')) {
					if (!megaMenus) return
					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0
							megaMenu.style.display = 'none'
							hideMenuTimeout = setTimeout(() => {
								megaMenu.style.display = 'none'
							}, 100)
						}
					})
				}
			})
			link.addEventListener('focus', (e) => {
				if (link.classList.contains('list-menu--megamenu')) {
					link.classList.add('list-menu--megamenu-visible')

					if (!megaMenus) return
					megaMenus.forEach((megaMenu) => {
						const megaMenuPositionRight = megaMenu.getBoundingClientRect().right
						const windowRight = window.innerWidth
						if (megaMenuPositionRight > windowRight) {
							megaMenu.style.right = '0'
						}
					})

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
		})
		menu.addEventListener('mouseleave', (e) => {
			if (!megaMenus) return
			setTimeout(() => {
				megaMenus.forEach((megaMenu) => {
					megaMenu.style.right = 'auto'
					megaMenu.style.display = 'none'
				})
			}, 100)
			menuLinks.forEach((link) => {
				link.classList.remove('list-menu--megamenu-visible')
			})
		})
		menu.addEventListener('focusout', (e) => {
			if (!megaMenus) return
			setTimeout(() => {
				megaMenus.forEach((megaMenu) => {
					megaMenu.style.right = 'auto'
				})
			}, 500)
			menuLinks.forEach((link) => {
				link.classList.remove('list-menu--megamenu-visible')
			})
		})

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').mouseenter(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focus(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focusin(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}
		megaMenuTabs()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main.querySelectorAll('.shopify-section')[0] &&
			main
				.querySelectorAll('.shopify-section')[0]
				.classList.contains('section--has-overlay')
		) {
		}

		const menuCloseBtn = document.querySelector('.header__modal-close-button')
		const mobileMenuDrawer = document.querySelector('header-drawer')
		menuCloseBtn.addEventListener('click', (e) => {
			mobileMenuDrawer.closeMenuDrawer(e)
		})
	}
	   document.addEventListener("DOMContentLoaded", () => {
        const headerIcons = document.querySelector(".header__icons");
      
        if (headerIcons && !document.querySelector('.request-pricing-wrapper')) {
          const requestPricingButton = document.createElement('div');
          requestPricingButton.className = 'request-pricing-wrapper topbar-wrapper__column';
          requestPricingButton.innerHTML = '<a href="/pages/contact-pravada" class="topbar-button" aria-label="Contact Pravada" rel="noopener">Contact Us</a>';
          headerIcons.insertAdjacentElement('afterbegin', requestPricingButton);
        }
      });

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)

	header()
})()
